// École Nid Douillet - Analytics Page
// 
// Analytics and reporting dashboard for directors

import React from 'react';
import AnalyticsDashboard from '@/components/analytics/AnalyticsDashboard';

const AnalyticsPage: React.FC = () => {

  return (
    <div className="p-6">
      <AnalyticsDashboard />
    </div>
  );
};

export default AnalyticsPage;
